import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Lock, ShoppingBag, FolderLock, LogIn } from "lucide-react";
import { useCustomerAuth } from "../contexts/CustomerAuthContext";
import { useContent } from "../contexts/SiteContentContext";

const links = [
  { to: "/", label: "Início" },
  { to: "/casos", label: "Casos" },
  { to: "/como-funciona", label: "Como Funciona" },
  { to: "/loja", label: "Loja" },
  { to: "/contacto", label: "Contacto" },
];

export default function Navbar() {
  const loc = useLocation();
  const { user } = useCustomerAuth() || {};
  const g = useContent("global");

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-ink-50/80 border-b border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-3 group">
          <img
            src={g.logo_url || "https://customer-assets.emergentagent.com/job_dossier-mystery/artifacts/13m4sz09_956183d9-214d-4237-bfe0-325064ecc672.png"}
            alt={g.brand_full || "Crimes em Casa"}
            className="h-12 md:h-14 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
          />
          <span className="mono text-[10px] text-bone-muted hidden md:inline ml-1 tracking-[0.3em] border-l border-white/15 pl-3">
            // DOSSIER
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}
              className={`mono text-[11px] uppercase tracking-[0.25em] transition-colors ${
                loc.pathname === l.to ? "text-white" : "text-bone-muted hover:text-white"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <Link
              to="/meus-casos"
              data-testid="navbar-meus-casos"
              className="inline-flex items-center gap-2 mono text-[11px] uppercase tracking-[0.25em] text-blood hover:text-white border border-blood/40 hover:border-white px-3 py-2 transition-colors"
            >
              <FolderLock className="w-3.5 h-3.5" />
              <span className="hidden sm:inline">Os meus casos</span>
            </Link>
          ) : (
            <Link
              to="/entrar"
              data-testid="navbar-login"
              className="inline-flex items-center gap-2 mono text-[11px] uppercase tracking-[0.25em] text-bone-muted hover:text-white"
            >
              <LogIn className="w-3.5 h-3.5" />
              <span className="hidden sm:inline">Entrar</span>
            </Link>
          )}
          <Link
            to="/loja"
            data-testid="navbar-shop-btn"
            className="hidden md:inline-flex items-center gap-2 mono text-[11px] uppercase tracking-[0.25em] text-bone-muted hover:text-white"
          >
            <ShoppingBag className="w-4 h-4" /> Loja
          </Link>
          <Link
            to="/admin/login"
            data-testid="navbar-admin-link"
            className="inline-flex items-center gap-2 mono text-[10px] uppercase tracking-[0.25em] text-bone-faded hover:text-blood transition-colors"
          >
            <Lock className="w-3 h-3" />
          </Link>
        </div>
      </div>
    </header>
  );
}
